import React from 'react';

const ServicesPrice = ({ onOpenApplicationModal }) => {
    return (
        <div className="services-price-section">
            {/* Убран заголовок "Стоимость индивид. Подбора..." */}

            <div className="services-price-container">
                <div className="services-price-info">
                    <div className="services-includes">
                        <h3 className="services-includes-title">ЧТО ВХОДИТ В НАШИ УСЛУГИ</h3>

                        <ul className="services-list">
                            <li>Консультация и подбор автомобиля</li>
                            {/* Удален второй пункт (проверка авто) */}
                            <li>Полная проверка нашими экспертами в Европе</li>
                            <li>Сопровождение сделки</li>
                            <li>Информирование и отчеты клиенту</li>
                            <li>Доставка автомобиля к Заказчику</li>
                            <li>Таможенное оформление</li>
                            <li>Помощь с постановкой в ГИБДД</li>
                        </ul>
                    </div>

                    <div className="services-price-block">
                        <div className="services-price-amount">70 000 руб.</div>
                        <button
                            className="button primary application-button"
                            onClick={onOpenApplicationModal}
                        >
                            ОСТАВИТЬ ЗАЯВКУ
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServicesPrice;